import React, { useEffect, useState, Fragment, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { CircularProgress, Divider, FormHelperText, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import ReCAPTCHA from 'react-google-recaptcha';
import { Button } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { getData, postData } from '../../services/fetch-service';
import { styled } from '@mui/material/styles';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { IoIosInformationCircle, IoMdClose } from "react-icons/io";
import { setPaymentResponse } from '../store/dataslice';
import dayjs from 'dayjs';
import PayseraPayment from '../PayseraPayment';
import { FaEuroSign } from 'react-icons/fa';
import { LoadingOverlay, Loader } from '@mantine/core';
import Swal from 'sweetalert2';
import { animateScroll } from 'react-scroll';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const customLoader = (
    <div className="payment-load">
        <Loader color="#006" />
        <span>Në procesim...</span>
    </div>
);

const Atk_PaymentFields = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const reCaptchaRef = useRef(null);
    const [updateLoader, setUpdateLoader] = useState(false);

    const SelectedPayment = useSelector((state) => state.Website.data.PaymentSelected);
    const [NumriSerik, setNumriSerik] = useState();
    const [NumriFiskal, setNumriFiskal] = useState();
    const [InstitucioniServiceData, setInstitucioniServiceData] = useState(null);
    const [FiskalData, setFiskalData] = useState(null);
    const [kerkoLoading, setKerkoLoading] = useState(false);
    const [kerkoFiskalLoading, setKerkoFiskalLoading] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [Loan, setLoan] = useState(false);

    // const fetchInstitucioniServiceData = async (token) => {
    //     try {
    //         const response = await getData(`Pagesat/GetKontrolloPagesat?uniref=${NumriSerik}&SherbimiTipiID=3&token=${token}`);
    //         if (response) {
    //             setInstitucioniServiceData(response.data);
    //             setKerkoLoading(false);
    //         }
    //     } catch (error) {
    //         setKerkoLoading(false);
    //         setInstitucioniServiceData(null);
    //         Swal.fire({
    //             icon: 'error',
    //             title: 'Gabim',
    //             text: "Pagesa me këtë UNIREF nuk është gjetur!"
    //         });
    //     }
    // };

    const fetchInstitucioniServiceData = async (token) => {
        try {
            const response = await postData('Pagesat/GetKontrolloPagesat', {
                SherbimiTipiID: 3,
                uniref: NumriSerik,
                token: token
            });
            if (response) {
                setInstitucioniServiceData(response.data);
                setKerkoLoading(false);
            }
        } catch (error) {
            setKerkoLoading(false);
            setInstitucioniServiceData(null);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: "Pagesa me këtë UNIREF nuk është gjetur!"
            });
        }
    };

    const fetchFiskalServiceData = async () => {
        try {
            const response = await getData(`Pagesat/GetTaxDeclarationByFiscalNr?fiscalNr=${NumriFiskal}`);
            if (response) {
                const data = response.data.respond;

                const sortedData = [...data].sort((a, b) => {
                    const yearComparison = b.tp_Year - a.tp_Year;
                    return yearComparison === 0 ? b.tp_Month - a.tp_Month : yearComparison;
                });

                setFiskalData(sortedData);
                setKerkoFiskalLoading(false);
            }
        } catch (error) {
            setKerkoFiskalLoading(false);
            setFiskalData(null);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: "Kërkimi me këtë numer fiskal nuk është gjetur!"
            });
        }
    };

    async function handleSearch() {
        // event.preventDefault();
        reCaptchaRef.current.reset();
        try {
            setKerkoLoading(true);
            const token = await reCaptchaRef.current.executeAsync();
            fetchInstitucioniServiceData(token);
        } catch (error) {
            setKerkoLoading(true);
        }
    };

    const handleFiskalSearch = () => {
        setKerkoFiskalLoading(true);
        fetchFiskalServiceData();
    };

    const handleBack = () => {
        navigate('/');
    }

    const [pagesaLoading, setPagesaLoading] = useState(false);
    const [loanLoading, setLoanLoading] = useState(false);

    const [shumaValue, setShumaValue] = useState();
    const today = new Date();
    const strDataPageses = dayjs(today).format('DD/MM/YYYY');

    const handleShumaChange = (event) => {
        setShumaValue(event.target.value);
        formik.setFieldValue('shuma', event.target.value)
    };

    useEffect(() => {
        if (InstitucioniServiceData && InstitucioniServiceData.Amount) {
            setShumaValue(InstitucioniServiceData.Amount);
        }

    }, [InstitucioniServiceData])


    const payment_validationSchema = Yup.object().shape({
        Email: Yup.string().email('Email nuk është valid!').required('Email është obligativ!'),
        shuma: Yup.string().required('Shuma është obligative!'),
    });

    const formik = useFormik({
        initialValues: {
            Email: '',
            shuma: null,
        },
        validationSchema: payment_validationSchema,
        onSubmit: (values) => {
            reCaptchaRef.current.reset();
            postPagesaPerSherbime(values)
        },
    });

    const [handlePayCounter, setHandlePayCounter] = useState(0);

    useEffect(() => {
        if (formik.errors.Email && handlePayCounter === 1) {
            setHandlePayCounter(0);
            const Toast = Swal.mixin({
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: `${formik.errors.Email}`
            });

            const emailInput = document.getElementById('email-input');
            if (emailInput) {
                const newPosition = emailInput.offsetTop - 300;

                animateScroll.scrollTo(newPosition, {
                    duration: 500,
                    smooth: true
                });
            }

            const emailInputTx = document.getElementById('email-input-tx');
            if (emailInputTx) {
                emailInputTx.focus();
            }

        } else if (!formik.errors.Email && formik.errors.shuma && handlePayCounter === 1) {
            setHandlePayCounter(0);
            const Toast = Swal.mixin({
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: `${formik.errors.shuma}`
            });

            const shumaInput = document.getElementById('shuma-input');
            if (shumaInput) {
                const newPosition = shumaInput.offsetTop - 300;

                animateScroll.scrollTo(newPosition, {
                    duration: 500,
                    smooth: true
                });
            }

            const shumaInputNr = document.getElementById('shuma-input-nr');
            if (shumaInputNr) {
                shumaInputNr.focus();
            }
        }
    }, [formik.errors.Email, handlePayCounter]);


    const handlePay = async () => {
        formik.validateForm().then(async (errors) => {
            if (Object.keys(errors).length === 0) {
                setPagesaLoading(true);
                await getProvizioni();
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
                setHandlePayCounter(prev => prev + 1);
            }
        });
    };

    const handlePayWithLoan = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setLoanLoading(true);
                setLoan(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
                setHandlePayCounter(prev => prev + 1);
            }
        });
    }

    const postPagesaPerSherbime = async (data) => {
        const token = await reCaptchaRef.current.executeAsync();
        try {
            setUpdateLoader(true);
            const newData = {
                ...data,
                shuma: shumaValue,
                emri: InstitucioniServiceData.serviceData.taxPayer_Name,
                mbiemri: '/',
                numriIdentifikues: InstitucioniServiceData.serviceData.fiscalNo,
                institucioniId: InstitucioniServiceData.institucioniId,
                provizioni: provizioni && provizioni.provizioni,
                viti: InstitucioniServiceData.serviceData.tp_Year,
                muaji: InstitucioniServiceData.serviceData.tp_Month,
                strProvizioni: `${provizioni && provizioni.provizioni}`,
                llojiPagesesID: 15,
                numriSerik: NumriSerik,
                numriUnikPageses: InstitucioniServiceData.serviceData.uniref,
                strDataPageses: `${strDataPageses}`,
                pershkrimi: InstitucioniServiceData.pershkrimi || 'Pagesë për ATK',
                strVlera: `${provizioni && provizioni.strShuma}`,
                strVleraTotale: `${provizioni && provizioni.strtotal_pagesa}`,
                paymentMethod: 3,
                sherbimiTipiID: 3,
                unirefOK: false,
                token: token,
                PayWithLoan: Loan ? true : false,
                verejtje: `${InstitucioniServiceData.serviceData.fiscalNo} ${InstitucioniServiceData.serviceData.period} ${InstitucioniServiceData.serviceData.uniref}`
            }
            if (provizioni) {
                const response = await postData('Pagesat/PagesaPerSherbime', newData);
                if (response && response.status === 200) {
                    if (!Loan) {
                        dispatch(setPaymentResponse(response.data.respond));
                        setPagesaLoading(false);
                    } else {
                        setLoanLoading(false);
                        const paymentWindow = window.open('', '_self');
                        paymentWindow.location.href = `${response.data.link}`;
                    }
                }
            }
        } catch (error) {
            setLoanLoading(false);
            setPagesaLoading(false);
            setUpdateLoader(false);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: `${error.response ? error.response.data.modelState.Error.errors[0].errorMessage : "Pagesa dështoi!"}`
            });
        }
    }

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleRowClick = (row) => {
        setSelectedRow(row);
        setOpen(false);
        setNumriSerik(row.uniref)
    };

    useEffect(() => {
        if (selectedRow !== null) {
            handleSearch();
        }

    }, [selectedRow]);


    // provisioni

    const [provizioni, setProvizioni] = useState(null);

    const getProvizioni = async (data) => {
        try {
            const response = await getData(`Pagesat/GetProvision?LlojiPagesesID=15&Amount=${formik.values.shuma}`, data);
            if (response) {
                setProvizioni(response.data)
            }
        } catch (error) {
            // setInstitucioniList(null);
        }
    }

    useEffect(() => {
        if (formik.values.shuma !== '') {
            getProvizioni();
        }
    }, [InstitucioniServiceData]);

    // provizioni end ***

    return (
        <div className="paysera-home paysera-feilds">
            <div className="home-header">
                <h1 className='headline-font'>
                    {SelectedPayment.description}
                </h1>

            </div>
            <div className="paysera-form-body">
                <div className="form-box atk search-box">
                    <div className="form-body search-body">
                        <div className="paysera-form search-s atk-s">
                            <div className="paysera-hs">
                                <Fragment>
                                    <Button variant="outlined btn-link" onClick={handleClickOpen}>
                                        Kërkoni nëpërmjet numrit fiskal
                                    </Button>
                                    <BootstrapDialog
                                        onClose={handleClose}
                                        aria-labelledby="customized-dialog-title"
                                        open={open}
                                    >
                                        <DialogTitle className="dialog-title" sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                            Kërkoni nëpërmjet numrit fiskal
                                        </DialogTitle>
                                        <IconButton
                                            aria-label="close"
                                            onClick={handleClose}
                                            sx={{
                                                position: 'absolute',
                                                right: 8,
                                                top: 8,
                                                color: (theme) => theme.palette.grey[500],
                                            }}
                                        >
                                            <IoMdClose />
                                        </IconButton>
                                        <DialogContent dividers>
                                            <div className="dialog-search">
                                                <div className="paysera-inputLabel s-Label">
                                                    <label htmlFor="Numri Serik">Kërko përmes numrit fiskal <span className="required">*</span></label>
                                                    <div className="s-input">
                                                        <OutlinedInput
                                                            size="small"
                                                            id="outlined-adornment-input"
                                                            placeholder="Numri fiskal"
                                                            value={NumriFiskal}
                                                            aria-describedby="outlined-input-helper-text"
                                                            inputProps={{
                                                                'aria-label': 'input',
                                                            }}
                                                            onChange={(event) => setNumriFiskal(event.target.value)}
                                                            onKeyPress={(event) => {
                                                                if (event.key === 'Enter' && NumriFiskal !== undefined) {
                                                                    handleFiskalSearch();
                                                                }
                                                            }}
                                                        />
                                                        <Button
                                                            type="button"
                                                            className="dynamic-button"
                                                            variant="contained"
                                                            onClick={handleFiskalSearch}
                                                            disabled={kerkoFiskalLoading || NumriFiskal === undefined || NumriFiskal === ''}
                                                        // startIcon={kerkoLoading && <CircularProgress size={20} color="inherit" />}
                                                        >
                                                            {kerkoFiskalLoading ? <CircularProgress size={24} /> : 'Kërko'}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                            {FiskalData && FiskalData.length > 0 &&
                                                // <TableContainer component={Paper}>
                                                <div className="table-dt">
                                                    <Table stickyHeader className="fiskal-table" style={{ maxWidth: '100%', overflow: 'auto' }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>UNIREF</TableCell>
                                                                <TableCell>Periudha</TableCell>
                                                                <TableCell>Viti</TableCell>
                                                                <TableCell>Muaji</TableCell>
                                                                <TableCell>Taksapaguesi</TableCell>
                                                                <TableCell>Emri</TableCell>
                                                                <TableCell>Numri Telefonit</TableCell>
                                                                <TableCell>Numri Formës</TableCell>
                                                                <TableCell>Lloji deklarimit</TableCell>
                                                                <TableCell>Lloji i kontributit</TableCell>
                                                                <TableCell>Adresa</TableCell>
                                                                <TableCell>Statusi pagesës</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {FiskalData.map((row) => (
                                                                <TableRow
                                                                    key={row.uniref}
                                                                    selected={selectedRow && selectedRow.uniref === row.uniref}
                                                                    onClick={() => handleRowClick(row)}
                                                                >
                                                                    <TableCell>{row.uniref || '/'}</TableCell>
                                                                    <TableCell>{row.period || '/'}</TableCell>
                                                                    <TableCell>{row.tp_Year || '/'}</TableCell>
                                                                    <TableCell>{row.tp_Month || '/'}</TableCell>
                                                                    <TableCell>{row.taxPayer_Name || '/'}</TableCell>
                                                                    <TableCell>{row.contact_Name || '/'}</TableCell>
                                                                    <TableCell>{row.phoneNo || '/'}</TableCell>
                                                                    <TableCell>{row.formNo || '/'}</TableCell>
                                                                    <TableCell>{
                                                                        row.declarationType === 0 ? "Dosier" :
                                                                            row.declarationType === 1 ? "e-Deklarimi" :
                                                                                row.declarationType === 2 ? "e-Filling" :
                                                                                    row.declarationType || '/'}
                                                                    </TableCell>
                                                                    <TableCell>{
                                                                        row.code === 0 ? "NONE" :
                                                                            row.code === 1 ? "TAX" :
                                                                                row.code === 2 ? "PENSION" :
                                                                                    row.code === 3 ? "HEALTH" :
                                                                                        row.code === 4 ? "Other" :
                                                                                            row.code || '/'}
                                                                    </TableCell>
                                                                    <TableCell>{row.address || '/'}</TableCell>
                                                                    <TableCell>{
                                                                        row.paymentStatus === 0 ? "PaPaguar" :
                                                                            row.paymentStatus === 1 ? "Paguar" :
                                                                                row.paymentStatus === 2 ? "Anuluar" :
                                                                                    row.paymentStatus || '/'}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                    {/* <MantineReactTable
                                                        className="mantine-table"
                                                        columns={aktivitetetColumns}
                                                        data={FiskalData ?? []}
                                                        enableGlobalFilter={true}
                                                        enableGlobalFilterModes={true}
                                                        enableFilterMatchHighlighting={true}
                                                        enableColumnActions={true}
                                                        enableGlobalFilterRankedResults={true}
                                                        enableBottomToolbar={true}
                                                        enableStickyHeader
                                                        // enableStickyFooter
                                                        search={true}
                                                        enableTopToolbar={true}
                                                        enableColumnFilters={true}
                                                        enablePagination={true}
                                                        state={{ isLoading: false }}
                                                    /> */}
                                                </div>
                                                // </TableContainer>
                                            }
                                        </DialogContent>
                                        <DialogActions>
                                            <Button autoFocus onClick={handleClose}>
                                                Kthehu
                                            </Button>
                                        </DialogActions>
                                    </BootstrapDialog>
                                </Fragment>
                                <div className="paysera-inputLabel s-Label">
                                    <label htmlFor="Numri Serik">Kërko përmes UNIREF <span className="required">*</span></label>
                                    <div className="s-input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="UNIREF"
                                            value={NumriSerik}
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            onChange={(event) => setNumriSerik(event.target.value.toUpperCase())}
                                            onKeyPress={(event) => {
                                                if (event.key === 'Enter' && NumriSerik !== undefined) {
                                                    handleSearch();
                                                }
                                            }}
                                        />
                                        <Button
                                            type="button"
                                            className="dynamic-button"
                                            variant="contained"
                                            onClick={handleSearch}
                                            disabled={kerkoLoading || NumriSerik === undefined || NumriSerik === ''}
                                        // startIcon={kerkoLoading && <CircularProgress size={20} color="inherit" />}
                                        >
                                            {kerkoLoading ? <CircularProgress size={24} /> : 'Kërko'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-box">
                    <Divider className="subheading-font" textAlign="center">Detajet e pagesës</Divider>
                    <div className="form-body">
                        {InstitucioniServiceData && InstitucioniServiceData.serviceData ? (
                            <div className="paysera-form">
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Fiskal">Numri Fiskal</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Numri Fiskal"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.serviceData.fiscalNo || ''}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Viti">Viti</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Viti"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.serviceData.tp_Year}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Muaji">Muaji</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Muaji"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.serviceData.tp_Month}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Periudha Raportimit">Periudha Raportimit</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Periudha Raportimit"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.serviceData.period}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Lloji i kontributi">Lloji i kontributit</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Lloji i kontributit"
                                        disabled
                                        type="text"
                                        value={
                                            InstitucioniServiceData.serviceData.code === 0 ? "NONE" :
                                                InstitucioniServiceData.serviceData.code === 1 ? "TAX" :
                                                    InstitucioniServiceData.serviceData.code === 2 ? "PENSION" :
                                                        InstitucioniServiceData.serviceData.code === 3 ? "HEALTH" :
                                                            InstitucioniServiceData.serviceData.code === 4 ? "Other" :
                                                                InstitucioniServiceData.serviceData.code
                                        }
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                    <Tooltip placement="top" className='p-tooltip' title="Lloji i kontributit: NONE, TAX, PENSION, HEALTH, Other">
                                        <IconButton>
                                            <IoIosInformationCircle />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Emri taksapaguesit">Emri taksapaguesit</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Emri taksapaguesit"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.serviceData.taxPayer_Name}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Personi kontaktues</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Personi kontaktues"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.serviceData.contact_Name}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Numri telefonit</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Numri telefonit"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.serviceData.phoneNo}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Adresa</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Adresa"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.serviceData.address}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div id="email-input" className="paysera-inputLabel">
                                    <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Numri Serik">Email <span className="required">*</span></label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="email-input-tx"
                                            placeholder="Shëno email-in tuaj"
                                            name='Email'
                                            type="email"
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            value={formik.values.Email}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.Email && formik.errors.Email}
                                        />
                                        {
                                            (formik.touched.Email && formik.errors.Email) &&
                                            (
                                                <FormHelperText>{formik.errors.Email}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Numri formës</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Numri formës"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.serviceData.formNo}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                    <Tooltip placement="top" className='p-tooltip' title="Numri i formes per llojin e tatimit dhe versionin">
                                        <IconButton>
                                            <IoIosInformationCircle />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Lloji deklarimit</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Lloji deklarimit"
                                        disabled
                                        type="text"
                                        value={
                                            InstitucioniServiceData.serviceData.declarationType === 0 ? "Dosier" :
                                                InstitucioniServiceData.serviceData.declarationType === 1 ? "e-Deklairmi" :
                                                    InstitucioniServiceData.serviceData.declarationType === 2 ? "e-Filling" :
                                                        InstitucioniServiceData.serviceData.declarationType
                                        }
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                    <Tooltip placement="top" className='p-tooltip' title="Mënyra e shkarkimit: eDeklarimi- per deklaratat e shkarkuara eFiling- per deklaratat nga EDI  Dosier- Deklaratat e shkarkuara nga Dosieri">
                                        <IconButton>
                                            <IoIosInformationCircle />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Statusi pageses</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Statusi pageses"
                                        disabled
                                        type="text"
                                        value={
                                            InstitucioniServiceData.serviceData.paymentStatus === 0 ? "PaPaguar" :
                                                InstitucioniServiceData.serviceData.paymentStatus === 1 ? "Paguar" :
                                                    InstitucioniServiceData.serviceData.paymentStatus === 2 ? "Anuluar" :
                                                        InstitucioniServiceData.serviceData.paymentStatus
                                        }
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                    <Tooltip placement="top" className='p-tooltip' title="Statusi i pageses se deklarates: PaPaguar,Paguar, Anuluar">
                                        <IconButton>
                                            <IoIosInformationCircle />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <div id="shuma-input" className="paysera-inputLabel">
                                    <label className={formik.touched.shuma && formik.errors.shuma ? 'label-top' : ''} htmlFor="Shuma për pagesë">
                                        Shuma për pagesë <span className="required">*</span>
                                    </label>

                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="shuma-input-nr"
                                            type='number'
                                            name='shuma'
                                            placeholder="Shuma për pagesë"
                                            className='number-input'
                                            aria-describedby="outlined-input-helper-text"
                                            value={shumaValue}
                                            endAdornment={<FaEuroSign />}
                                            onChange={handleShumaChange}
                                            inputProps={{
                                                'aria-label': 'input',
                                                // inputMode: 'numeric'
                                            }}
                                            onBlur={(e) => {
                                                formik.handleBlur(e);
                                                getProvizioni();
                                            }}
                                            error={formik.touched.shuma && formik.errors.shuma}
                                        />
                                        {
                                            (formik.touched.shuma && formik.errors.shuma) &&
                                            (
                                                <FormHelperText>{formik.errors.shuma}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Provizioni"> Provizioni</label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Provizioni"

                                            readOnly
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            name='Provizioni'
                                            value={provizioni && provizioni.provizioni}
                                        />
                                    </div>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Provizioni">Shuma Totale</label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Provizioni"
                                            endAdornment={<FaEuroSign />}
                                            readOnly
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            name='strVleraTotale'
                                            value={provizioni && provizioni.strtotal_pagesa}
                                        />
                                    </div>
                                </div>
                                <div className="p-buttons">
                                    <div className="payForm-btn">
                                        <Button type="button" variant="outlined" onClick={handleBack}>
                                            Kthehu
                                        </Button>
                                        <Button
                                            id="payNow"
                                            type="button"
                                            variant="contained"
                                            onClick={handlePayWithLoan}
                                            // disabled
                                            disabled={loanLoading}
                                            startIcon={loanLoading && <CircularProgress size={20} color="inherit" />}
                                        >
                                            {loanLoading ? 'Loading...' : 'Paguaj përmes kredisë'}
                                        </Button>
                                        <Button
                                            id="payNow"
                                            type="button"
                                            variant="contained"
                                            onClick={handlePay}
                                            disabled={pagesaLoading}
                                            startIcon={pagesaLoading && <CircularProgress size={20} color="inherit" />}
                                        >
                                            {pagesaLoading ? 'Duke paguar...' : 'Paguaj'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Fragment>
                                <div className="skeletonBox-detajet">
                                    <h4 className="skeleton-title-font" >Për të shfaqur detajet e pagesës kërkoni përmes UNIREF.</h4>
                                </div>
                                <div className="skeleton-btn">
                                    <Button type="button" variant="outlined" onClick={handleBack}>
                                        Kthehu
                                    </Button>
                                </div>
                            </Fragment>
                        )}
                    </div>
                </div>
            </div>
            <ReCAPTCHA
                badge="bottomleft"
                sitekey={process.env.REACT_APP_SITE_KEY}
                size="invisible"
                ref={reCaptchaRef}
            />
            <PayseraPayment />
            <LoadingOverlay loader={customLoader} visible={updateLoader} />
        </div>
    )
}

export default Atk_PaymentFields